import { CardCampType, PromotionalImagesObj, RecruitPageType } from '@/pages/backend/cardCamp';
import { TCerObj } from '@/pages/backend/cardCampSettings/nodeSettings/certificationCom';
import { TFrVideoObj } from '@/pages/backend/cardCampSettings/nodeSettings/videoCom/videoModal';
import { TConsoleSetingsCoupon } from '@/types/console/coupon';
import { ExerciseCategoryTree } from '@/types/console/exerciseCatrgory';
import { TConsoleSetingsNode } from '@/types/console/node';
import { TQuestionObj } from '@/types/console/question';
import { TConsoleReward } from '@/types/console/reward';
import { TApi, TOption } from '@/types/interface';
import {
  requestDelete,
  requestGet,
  requestPost,
  requestPostToFormData,
  requestPut,
} from '@/utils/request';

/**
 * 后台-获取打卡营列表
 */
export function getCampListInConsole(): Promise<TApi<CardCampType>> {
  return requestGet('/v2/camp/api/card/camp/list', {});
}

export function getCampInfoById(id: string): Promise<TApi<CardCampType & RecruitPageType>> {
  return requestGet(`/v2/camp/api/card/camp/${id}`);
}

export function uploadImageInConsole(file: File, path: string): Promise<TApi<string>> {
  return requestPostToFormData('/v2/camp/api/oss/upload', { file, path });
}

export function editRecruitPageById(
  id: string,
  params: {
    dynamicCommunication: {
      dynamicCommunication: boolean;
      index: number;
    };
    promotionalImages: Omit<PromotionalImagesObj, 'mode'>[];
  },
) {
  return requestPut(`/v2/camp/api/card/camp/${id}/recruit/page`, params);
}

// 获取打卡营的奖励
export function getCampRewardList(id: string): Promise<TApi<TConsoleReward[]>> {
  return requestGet(`/v2/camp/api/card/camp/reward/list/${id}`);
}

// 获取打卡营的节点
export function getCampNodes(id: string): Promise<TApi<TConsoleSetingsNode[]>> {
  return requestGet(`/v2/camp/api/card/camp/node/list/${id}`);
}

/**
 * 获取打卡营节点，只有id和name字段
 * @param id
 * @returns
 */
export function listCampNodeOption(id: string): Promise<TApi<TOption[]>> {
  return requestGet(`/v2/camp/api/card/camp/node/list/option/${id}`);
}

// 获取优惠卷类型
export function getCouponList(): Promise<TApi<TConsoleSetingsCoupon[]>> {
  return requestGet('/v2/camp/api/card/camp/reward/list/coupon');
}

// 创建奖励
export function createReward(params: any) {
  return requestPost('/v2/camp/api/card/camp/reward', params);
}

// 修改奖励
export function updateReward(id: string, params: any) {
  return requestPut(`/v2/camp/api/card/camp/reward/${id}`, params);
}

// 删除奖励
export function deleteRewardById(id: string) {
  return requestDelete(`/v2/camp/api/card/camp/reward/${id}`, {});
}

// 奖励排序
export function sortRewardList(array: { id: string; index: number }[]) {
  return requestPut(`/v2/camp/api/card/camp/reward/sort`, { items: array });
}

/**
 * 节点设置部分接口
 * */
// 节点排序
export function sortNodeList(array: { id: string; index: number }[]) {
  return requestPost(`/v2/camp/api/card/camp/node/sort`, { nodeIndex: array });
}

// 删除节点
export function deleteNodeById(id: string) {
  return requestDelete(`/v2/camp/api/card/camp/node/${id}`, {});
}

// 获取题库分类
export function getExerciseCategoryTree(): Promise<TApi<ExerciseCategoryTree>> {
  return requestGet(`/v2/camp/api/question/bank/category/tree`);
}

// 搜索题目
export function searchQuestion(key: string): Promise<TApi<{ records: TQuestionObj[] }>> {
  return requestPost(`/v2/camp/api/question/page`, { key });
}

// 创建打卡节点
export function createNode(params: any): Promise<TApi<TConsoleSetingsNode>> {
  return requestPost(`/v2/camp/api/card/camp/node`, params);
}

// 获取打卡节点详情
export function getNodeInfoById(id: string): Promise<TApi<TConsoleSetingsNode>> {
  return requestGet(`/v2/camp/api/card/camp/node/${id}`);
}

// 修改打卡节点
export function updateNodeInfo(id: string, params: any): Promise<TApi<TConsoleSetingsNode>> {
  return requestPut(`/v2/camp/api/card/camp/node/${id}`, params);
}
// 获取题目详情
export function getQuestionById(id: string): Promise<TApi<TQuestionObj>> {
  return requestGet(`/v2/camp/api/question/${id}`);
}
// 搜索免费视频
export function searchFreeVideo(
  current: number,
  key?: string,
): Promise<TApi<{ records: TFrVideoObj[]; total: number }>> {
  return requestPost(`/v2/camp/api/video/search`, { key, current });
}
// 获取职业认证列表
export function getCertList(): Promise<TApi<TCerObj[]>> {
  return requestGet(`/v2/camp/api/cert/list`);
}
// 获取文件的临时下载链接
export async function apiGetTempUploadUrl(params: {
  path: string;
  fileName: string;
  contentType: string;
}): Promise<
  TApi<{
    signedUrl: string;
    actualSignedRequestHeaders: {
      'Content-Type': string;
      Host: string;
    };
  }>
> {
  params.fileName = encodeURIComponent(params.fileName);
  // fetch(`/api/oss/upload/temporary/url?fileName=${params.fileName}&path=${params.path}&contentType=${params.contentType}`,{
  //   headers:{
  //
  //   }
  // })
  return requestGet('/v2/camp/api/camp/oss/temp/upload/url', params);
}
// 检验打卡营名称是否重复
export function isCampNameRepeated(params: { id?: string; name: string }): Promise<TApi<boolean>> {
  return requestGet('/v2/camp/api/card/camp/repeat', params);
}

export function getPlayUrl(playUrl: string): Promise<TApi<string>> {
  return requestPost(`/v2/camp/api/video/vod/play/url`, { playUrl });
}
